import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
// I18n
import { useTranslation } from "react-i18next";
import { Grid, Button, makeStyles, Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import {
  durationOptions,
  dateConfig,
  timeConfig,
  defaultSelection,
} from "../config";
import { properCase } from "utils";
import { clockedInMock } from "config/mock";

const useStyles = makeStyles({
  tableContainer: {},
  table: {
    // minWidth: 650,
    // marginBottom: 20
  },
  formControl: {
    //margin: theme.spacing(1),
    minWidth: 150,
    marginBottom: 20,
  },
  selectEmpty: {
    //marginTop: theme.spacing(2),
  },
  highlight: {
    backgroundColor: "#FDECEA",
  },
  full: {
    // width: "98%"
    display: "flex",
    alignItems: "center",
  },
});

const ClockedIn = (props) => {
  const { data } = props,
    { t } = useTranslation(),
    classes = useStyles(),
    [duration, setDuration] = useState(defaultSelection),
    punches = data != null && data != undefined ? data : [];

  const handleDurationChange = (event) => {
    setDuration(event.target.value);
  };

  // useEffect(() => {
  //   console.log(duration);
  // }, [duration]);

  return (
    <>
      {punches.length > 0 ? (
        <>
          <Grid container justify="left">
            <Grid item>
              <FormControl className={classes.formControl}>
                <Select
                  labelId="highlight-duration-helper-label"
                  id="highlight-duration"
                  value={duration}
                  onChange={handleDurationChange}
                >
                  <MenuItem value={defaultSelection}>
                    <InputLabel htmlFor="select-duration">
                      {properCase(t("general.selectDuration"))}
                    </InputLabel>
                  </MenuItem>
                  {durationOptions.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item + " " + properCase(t("general.lblHours"))}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <TableContainer
            component={Paper}
            className={classes.tableContainer}
            elevation="5"
          >
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("pgHome.lblName")}</TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblActivityName"))}
                  </TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblJobFamily"))}
                  </TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblTimeStamp"))}
                  </TableCell>
                  <TableCell align="right">
                    {properCase(t("pgHome.lblDuration"))}
                  </TableCell>
                  {/* <TableCell align="right">{t("pgHome.lblWeeklyTotal")} </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {punches.map((punch) => (
                  <TableRow
                    key={punch.name}
                    className={
                      punch.duration >= duration && duration !== "-1"
                        ? classes.highlight
                        : null
                    }
                  >
                    <TableCell component="th" scope="row">
                      {punch.name}
                    </TableCell>
                    <TableCell align="left">{punch.activity}</TableCell>
                    <TableCell align="left">{punch.jobFamily}</TableCell>
                    <TableCell align="left">
                      {moment(punch.startTime).format(dateConfig.format2) +
                        " " +
                        moment(punch.startTime).format(timeConfig.format3)}
                    </TableCell>
                    <TableCell align="right">{punch.duration}</TableCell>
                    {/* <TableCell align="right">{row.weeklyTotal}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <>
          <Box className={classes.full}>
            <Alert severity="info" style={{ width: "100%" }}>
              {t("pgHome.errNoReportData2")}
            </Alert>
          </Box>
        </>
      )}
    </>
  );
};

ClockedIn.propTypes = {
  data: PropTypes.array,
};

export default ClockedIn;
